import { CallState } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { InboxContext } from '../types';
import { setOutboundCallToCompleted } from '../callHandlers/outboundCalls';
import { setInternalCallToCompleted } from '../callHandlers/internalCalls';

function handleCallEnded(_context: InboxContext, event: CallState) {
  // if this is an outbound or inbound internal call, then we should mark the task as completed
  const task = TasksModule.getTask(event.callId);
  if (event.terminating) {
    if (task && task.isInternal) {
      setInternalCallToCompleted(_context, event.callId);
    }
  } else if (event.originating) {
    if (task && task.isOutbound) {
      setOutboundCallToCompleted(_context, event.callId);
    }
  }
}

export default handleCallEnded;
